import { createAction } from '../../../../store.model';
import { Chat } from '../../../../teams-call';
import { ActionType } from '../teamschat-dialog.action';

export interface Reload {
    chat?: Chat;
    errorCode?: number;
    userId: number;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.COACHING_DETAIL__TCD__RELOAD,
);

export interface ReloadResult extends Reload {}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.COACHING_DETAIL__TCD__RELOAD_RESULT,
);
